var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRounded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.02883 8.6087L1.42389 5.21739C0.984829 4.80435 0.886849 4.33174 1.12995 3.79957C1.37305 3.26739 1.80611 3.00087 2.42912 3H9.56967C10.1936 3 10.6271 3.26652 10.8702 3.79957C11.1133 4.33261 11.0149 4.80522 10.5749 5.21739L6.96996 8.6087C6.8313 8.73913 6.6811 8.83696 6.51934 8.90217C6.35758 8.96739 6.18426 9 5.99939 9C5.81453 9 5.64121 8.96739 5.47945 8.90217C5.31769 8.83696 5.16749 8.73913 5.02883 8.6087Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRounded);
export default __webpack_public_path__ + "static/media/arrow-rounded.201c4f463f9d6b802af902bf45c2c9a2.svg";
export { ForwardRef as ReactComponent };